'use client';

import TagList from '@/components/TagList';
import { TAGS_CHANGELOG } from '@/data/tags';

export default function TagsChangelog() {
  return <TagList tags={TAGS_CHANGELOG} />;
}
